/* istanbul ignore file */

import styled from 'styled-components'

export const ChartContainer = styled.div`
  width: 100%;
  height: 260px;
  flex-shrink: 0;
`
